<template>
	<hr class="divider" />
</template>

<style lang="scss" scoped>
.divider {
	background: #98a2b3;
	height: 1px;
	margin: 32px 0;
}
</style>
